import React from "react";
import AppInformePedidosAgrupadoReactTable from "../components/AppInformePedidosAgrupadoReactTable";

const InformePedidosAgrupado = () => {
  return (
    <>
      <AppInformePedidosAgrupadoReactTable />
    </>
  );
};

export default InformePedidosAgrupado;